import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ButtonBuyImprovement } from "./ButtonBuyImprovement";
import { ImprovementEffectsMaxLevel } from "./ImprovementEffectsMaxLevel";
import { ImprovementHeading } from "./ImprovementHeading";
import { ImprovementLockedLevelStatus } from "./ImprovementLockedLevelStatus";
import { ImprovementMaxLevelReached } from "./ImprovementMaxLevelReached";
import { ImprovementUpgradeEffects } from "./ImprovementUpgradeEffects";
import { ImprovementUpgradeRequirements } from "./ImprovementUpgradeRequirements";
export var Improvement = function (_a) {
    var buildingStage = _a.buildingStage, item = _a.item, buildingId = _a.buildingId, lockedLevelButton = _a.lockedLevelButton, lockedLevelText = _a.lockedLevelText;
    var balancing = item.balancing, level = item.level;
    var totalLevels = balancing.level.length;
    var hasMaxLevelReached = totalLevels === level;
    var itemUnlockRequirement = !hasMaxLevelReached
        ? balancing.level[level].unlockRequirement
        : undefined;
    var isUpgradeLocked = itemUnlockRequirement && itemUnlockRequirement.stageLevel > buildingStage;
    return (React.createElement("div", { className: "flex flex--guts " + IdStyles.DetailViewWrapper },
        React.createElement("div", { className: "improvement__detail-view " + IdStyles.DetailView }, hasMaxLevelReached ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "" + IdStyles.ImprovementMaxLevelReachedContainer },
                React.createElement(ImprovementHeading, { item: item }),
                React.createElement(ImprovementEffectsMaxLevel, { item: item })),
            React.createElement(ImprovementMaxLevelReached, null))) : (React.createElement(React.Fragment, null,
            React.createElement(ImprovementHeading, { item: item }),
            React.createElement(ImprovementUpgradeEffects, { item: item, isLocked: isUpgradeLocked }),
            isUpgradeLocked ? (React.createElement(React.Fragment, null,
                React.createElement(ImprovementLockedLevelStatus, { loca: lockedLevelText, level: itemUnlockRequirement.stageLevel }),
                lockedLevelButton)) : (React.createElement(React.Fragment, null,
                React.createElement(ImprovementUpgradeRequirements, { item: item }),
                React.createElement(ButtonBuyImprovement, { buildingId: buildingId, item: item }))))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/Improvement.tsx
// module id = 931
// module chunks = 3